export const PRODUCT_PLACEHOLDER = '/placeholder-product.svg';

const PLACEHOLDER_HINTS = ['no_image', 'no-image', 'noimage', 'sin_imagen', 'sinimagen', 'placeholder'];
const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Unii furnizori (ex. BTSWholesaler) trimit o poză neagră „lipsă produs" în loc să lase câmpul gol.
export const isSupplierPlaceholder = (url) =>
  typeof url === 'string' && PLACEHOLDER_HINTS.some((h) => url.toLowerCase().includes(h));

export const productImage = (url) =>
  !url || isSupplierPlaceholder(url) ? PRODUCT_PLACEHOLDER : url;

// Pozele furnizorilor au sute de KB; le trecem prin proxy-ul care le redimensionează și le dă în WebP.
export const optimizedImage = (url, width = 400) => {
  const src = productImage(url);
  if (!src.startsWith('http')) return src;
  return `${BACKEND}/api/img?w=${width}&u=${encodeURIComponent(src)}`;
};

export const imageSrcSet = (url, widths = [200, 400]) => {
  const src = productImage(url);
  if (!src.startsWith('http')) return undefined;
  return widths.map((w) => `${optimizedImage(src, w)} ${w}w`).join(', ');
};

export const reportBrokenImage = (productId) => {
  if (!productId || !BACKEND) return;
  const key = `imgbad:${productId}`;
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, '1');
  fetch(`${BACKEND}/api/products/image-broken`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: productId }),
    keepalive: true,
  }).catch(() => {});
};

export const productImages = (images, fallback) => {
  const list = (images || []).filter((i) => typeof i === 'string' && i && !isSupplierPlaceholder(i));
  if (list.length) return list;
  return [productImage(fallback)];
};
